import { put, call, all, takeLatest, select } from "redux-saga/effects";
import {
  // --------------EasyInest-----------------
  REQAnalyticList,
  RESAnalyticList,
  FailAnalyticList,
  // --------------UntHld-----------------
  REQAnalyticUntHldList,
  RESAnalyticUntHldList,
  FailAnalyticUntHldList,
  // --------------PVD-----------------
  REQAnalyticPVDList,
  RESAnalyticPVDList,
  FailAnalyticPVDList,
  // --------------PVD Excel Download-----------------
  REQAnalyticPVDExcelDownload,
  RESAnalyticPVDExcelDownload,
  FailAnalyticPVDExcelDownload
} from "./actions";
import moment from "moment";
import * as actions from "../../Authentication/redux/actions";

function* fetchAnalyticListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD } = payload;
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";
    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin/analyticUserAccount`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          // ---Search----
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();

    if (response) {
      yield put(RESAnalyticList(response));
    } else {
      yield put(RESAnalyticList());
    }
  } catch (error) {

    yield put(FailAnalyticList());
  }
}

function* fetchAnalyticUntHldListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD } = payload;
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";
    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin/analyticUnitHolder`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          // ---Search----
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();

    if (response) {
      yield put(RESAnalyticUntHldList(response));
    } else {
      yield put(RESAnalyticUntHldList());
    }
  } catch (error) {

    yield put(FailAnalyticUntHldList());
  }
}

function* fetchAnalyticPVDListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD, page = 1, per_page = 50, sort_by = 'B2C_CreateDate', sort_order = 'asc', filterType } = payload;

    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";

    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin-actions/pvdconversion`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD,
          page,
          per_page,
          sort_by,
          sort_order,
          filterType
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();
    if (process.env.NODE_ENV !== "production") {
      console.log('🔵 Full API Response:', response);
    }

    // Map API response to expected shape for the table
    if (response && response.data && Array.isArray(response.data)) {
      // Map backend summary keys to frontend expected keys
      const rawSummary = response.summary || {};
      const summary = {
        totalUsers: rawSummary.totalUsers ?? rawSummary.total_users ?? rawSummary.totalCount ?? 0,
        mfUnitholder: rawSummary.mfUnitholder ?? rawSummary.mf_unitholder ?? rawSummary.mfUnitholderCount ?? 0,
        pvdUnitholder: rawSummary.pvdUnitholder ?? rawSummary.pvd_unitholder ?? rawSummary.pvdUnitholderCount ?? 0,
        noUnitholder:
          rawSummary.noUnitholder ?? rawSummary.no_unitholder ??
          (rawSummary.totalCount !== undefined && rawSummary.mfUnitholderCount !== undefined && rawSummary.pvdUnitholderCount !== undefined
            ? rawSummary.totalCount - rawSummary.mfUnitholderCount - rawSummary.pvdUnitholderCount
            : 0)
      };

      console.log('✅ Mapped Summary:', summary);
      console.log('✅ Results Count:', response.data.length);

      yield put(RESAnalyticPVDList({
        results: response.data,
        pagination: response.pagination,
        summary,
        applied_filters: response.applied_filters,
        message: response.message,
        timestamp: response.timestamp
      }));
    } else {
      console.log('❌ Response structure mismatch:', response);
      yield put(RESAnalyticPVDList({ results: [], pagination: {}, summary: { totalUsers: 0, mfUnitholder: 0, pvdUnitholder: 0, noUnitholder: 0 } }));
    }
  } catch (error) {
    yield put(FailAnalyticPVDList());
  }
}

function* fetchAnalyticPVDExcelDownloadWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD, sort_by = 'B2C_CreateDate', sort_order = 'asc', filterType } = payload;

    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";

    console.log('🔵 PVD Excel Download API Call');
    console.log('📦 Payload:', { tStartD1, tEndD1, sort_by, sort_order, filterType });

    // Use the same endpoint as the main data fetch - get ALL records without pagination limit
    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin-actions/pvdconversion`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD,
          page: 1,
          per_page: 10000, // Large number to get all records for export
          sort_by,
          sort_order,
          filterType
        })
      }
    );

    console.log('📡 Excel Download API Response Status:', request.status);

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      yield put(FailAnalyticPVDExcelDownload());
      return null;
    }

    const response = yield request.json();
    console.log('✅ Excel Download API Response Data:', response);

    let allData = [];
    if (response && response.data && Array.isArray(response.data)) {
      allData = response.data;
    } else if (response && Array.isArray(response)) {
      allData = response;
    }

    yield put(RESAnalyticPVDExcelDownload(allData));
    return allData;
  } catch (error) {
    console.error('❌ PVD Excel Download Error:', error);
    yield put(FailAnalyticPVDExcelDownload());
    return null;
  }
}

export function* analyticListSaga() {
  yield all([
    takeLatest(REQAnalyticList, fetchAnalyticListWorker),
    takeLatest(REQAnalyticUntHldList, fetchAnalyticUntHldListWorker),
    takeLatest(REQAnalyticPVDList, fetchAnalyticPVDListWorker),
    takeLatest(REQAnalyticPVDExcelDownload, fetchAnalyticPVDExcelDownloadWorker)
  ]);
}